<template>
	<router-link class="category-thumbnail-container" :to="contentRoute">
		<div class="category-thumbnail-title">
			<h2>{{ title }}</h2>
		</div>
		<div class="category-thumbnail-image" v-if="imageUrl" :style="backgroundImage"></div>
	</router-link>
</template>

<script>
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';

export default {
	name: 'CategoryThumbnail',
	mixins: [contentDataLoaderMixin],
	props: {
		title: String,
		image: [String, Number],
		id: [String, Number],
	},
	computed: {
		contentRoute() {
			return `/posts/${this.id}`;
		},
		imageUrl() {
			if (this.image) {
				const media = this.findInMedia(this.image);
				if (media && media.original_name) {
					return `/storage/media/${media.original_name}`;
				}
			}
			return false;
		},
		backgroundImage() {
			return `background-image: url('${this.imageUrl}')`;
		},
	},
};
</script>

<style src="@/styles/components/CategoryThumbnail/CategoryThumbnail.less" lang="less" scoped></style>
